import { useState, useEffect } from 'react';
import axios from 'axios';

const api = axios.create({ baseURL: '/api' });
api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});


function UnmatchedCategoryRow({ cat, onMatch }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [matching, setMatching] = useState(false);
  const [done, setDone] = useState(false);

  const label = [cat.large_category, cat.middle_category, cat.small_category, cat.detail_category].filter(Boolean).join(' > ');

  const search = async () => {
    if (!query.trim()) return;
    setSearching(true);
    try {
      const r = await api.get('/product-settings/naver/categories/search', { params: { q: query.trim() } });
      setResults(r.data);
    } catch(err) { alert('검색 실패'); }
    finally { setSearching(false); }
  };

  const select = async (naverId) => {
    setMatching(true);
    try {
      await onMatch(cat.id, naverId);
      setDone(true);
    } catch(err) { alert('매칭 실패'); }
    finally { setMatching(false); }
  };

  if (done) return null;

  return (
    <div style={{ padding: '8px 0', borderBottom: '0.5px solid #f0f0f0' }}>
      <div style={{ fontSize: '12px', color: '#444', marginBottom: '6px' }}>{label}</div>
      <div style={{ display: 'flex', gap: '6px', marginBottom: results.length > 0 ? '6px' : 0 }}>
        <input value={query} onChange={e => setQuery(e.target.value)} onKeyDown={e => e.key === 'Enter' && search()}
          placeholder="네이버 카테고리 검색어 입력"
          style={{ fontSize: '12px', padding: '5px 8px', borderRadius: '6px', border: '0.5px solid #ddd', flex: 1 }} />
        <button onClick={search} disabled={searching}
          style={{ fontSize: '12px', padding: '5px 12px', borderRadius: '6px', border: '0.5px solid #185FA5', background: '#E6F1FB', color: '#185FA5', cursor: 'pointer' }}>
          {searching ? '검색 중...' : '검색'}
        </button>
      </div>
      {results.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', maxHeight: '140px', overflowY: 'auto', background: '#fafafa', borderRadius: '6px', padding: '6px' }}>
          {results.map(r => (
            <button key={r.id} onClick={() => select(r.id)} disabled={matching}
              style={{ fontSize: '11px', padding: '5px 8px', borderRadius: '5px', border: '0.5px solid #ddd', background: '#fff', color: '#444', textAlign: 'left', cursor: 'pointer' }}>
              {r.whole_name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
function CoupangApiSection({ showMsg }) {
  const [vendorId, setVendorId] = useState('');
  const [accessKey, setAccessKey] = useState('');
  const [secretKey, setSecretKey] = useState('');
  const [expiry, setExpiry] = useState('');
  const [daysLeft, setDaysLeft] = useState(null);

  const load = async () => {
    try {
      const r = await api.get('/orders/settings/coupang-api');
      setVendorId(r.data.vendor_id || '');
      setAccessKey(r.data.access_key ? '●●●●●●●●●●●●●●●●●●●●' : '');
      setSecretKey(r.data.secret_key ? '●●●●●●●●●●●●●●●●●●●●' : '');
      setExpiry(r.data.expiry || '');
      if (r.data.expiry) {
        const diff = new Date(r.data.expiry) - new Date();
        setDaysLeft(Math.ceil(diff / (1000 * 60 * 60 * 24)));
      }
    } catch(e) { console.error(e); }
  };

  useEffect(() => { load(); }, []);

  return (
    <Section title="쿠팡 API" desc="쿠팡 Wing Open API 키를 관리합니다">
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '500px' }}>
        <div>
          <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>Vendor ID</div>
          <input value={vendorId} onChange={e => setVendorId(e.target.value)} placeholder="Vendor ID"
            style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
        </div>
        <div>
          <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>Access Key</div>
          <input value={accessKey} onChange={e => setAccessKey(e.target.value)} placeholder="Access Key"
            style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
        </div>
        <div>
          <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>Secret Key</div>
          <input value={secretKey} onChange={e => setSecretKey(e.target.value)} placeholder="Secret Key"
            style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
        </div>
        <div>
          <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>만료일 (YYYY-MM-DD)</div>
          <input value={expiry} onChange={e => setExpiry(e.target.value)} placeholder="예: 2026-10-18"
            style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
        </div>
        {daysLeft !== null && (
          <div style={{ fontSize: '12px', color: daysLeft <= 14 ? '#854F0B' : '#444' }}>
            만료까지 D-{daysLeft <= 0 ? 'day (만료됨)' : daysLeft}
          </div>
        )}
        <button onClick={async () => {
          if (accessKey.includes('●') || secretKey.includes('●')) return alert('변경할 값을 새로 입력해주세요.');
          await api.post('/orders/settings/coupang-api', { vendor_id: vendorId, access_key: accessKey, secret_key: secretKey, expiry });
          showMsg('저장됐습니다');
          load();
        }} style={{ fontSize: '12px', padding: '8px 20px', borderRadius: '8px', border: 'none', background: '#1D9E75', color: '#fff', cursor: 'pointer', fontWeight: '500', alignSelf: 'flex-start' }}>저장</button>
      </div>
    </Section>
  );
}

function Section({ title, desc, children }) {
  return (
    <div style={{ background: '#fff', border: '0.5px solid #e8e8e8', borderRadius: '12px', overflow: 'hidden', marginBottom: '16px' }}>
      <div style={{ padding: '14px 18px', borderBottom: '0.5px solid #e8e8e8', background: '#fafafa' }}>
        <div style={{ fontSize: '13px', fontWeight: '500', color: '#1a1a1a' }}>{title}</div>
        {desc && <div style={{ fontSize: '11px', color: '#aaa', marginTop: '3px' }}>{desc}</div>}
      </div>
      <div style={{ padding: '16px 18px' }}>{children}</div>
    </div>
  );
}
// [설계 원칙 - 2026-09-03] 셀러허브는 판매자가 브랜드를 관리자에 등록 신청하고 MD 승인을 받아야
// 그 브랜드명/코드를 상품등록에 쓸 수 있다. 목록이 계속 늘어나므로 DB 하드코딩 대신
// 이 화면에서 사용자가 직접 추가/삭제한다. 등록 시 여기 없는 브랜드는 사전 차단하지 않고,
// 엑셀 전송을 그대로 시도하며 실패 사유(브랜드 불일치)를 그대로 보여준다.
function SellerhubBrandSection() {
  const [brands, setBrands] = useState([]);
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [aliases, setAliases] = useState('');
  const [loading, setLoading] = useState(false);

  const fetchBrands = () => {
    api.get('/product-settings/sellerhub-brands').then(r => setBrands(r.data || []));
  };
  useEffect(() => { fetchBrands(); }, []);

  const addBrand = async () => {
    if (!name.trim() || !code.trim()) return alert('브랜드명과 코드를 모두 입력해주세요');
    setLoading(true);
    try {
      await api.post('/product-settings/sellerhub-brands', { brand_name: name.trim(), brand_code: code.trim(), aliases: aliases.trim() });
      setName(''); setCode(''); setAliases('');
      fetchBrands();
    } catch (err) {
      alert('저장 실패: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };
  const deleteBrand = async (id) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    await api.delete(`/product-settings/sellerhub-brands/${id}`);
    fetchBrands();
  };

  // 기존 브랜드의 별칭을 나중에 추가/수정할 수 있어야 하므로, 항목을 클릭하면 인라인 편집으로 전환한다.
  const [editingId, setEditingId] = useState(null);
  const [editAliases, setEditAliases] = useState('');
  const startEdit = (b) => { setEditingId(b.id); setEditAliases(b.aliases || ''); };
  const saveEdit = async (b) => {
    setLoading(true);
    try {
      await api.post('/product-settings/sellerhub-brands', { brand_name: b.brand_name, brand_code: b.brand_code, aliases: editAliases.trim() });
      setEditingId(null);
      fetchBrands();
    } catch (err) {
      alert('저장 실패: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Section title="셀러허브 브랜드 매칭" desc="셀러허브에 브랜드 등록 신청 후 MD 승인을 받으면, 여기에 브랜드명과 코드를 추가해주세요. 별칭에는 우리 상품에 입력된 브랜드 표기(예: 해태제과)가 셀러허브 등록명(예: 해태)과 다를 때, 쉼표로 구분해 추가로 입력하세요. 이미 등록된 브랜드는 아래 목록에서 클릭하면 별칭을 추가/수정할 수 있습니다">
      <div style={{ display: 'flex', gap: '8px', marginBottom: '14px' }}>
        <input value={name} onChange={e => setName(e.target.value)} placeholder="브랜드명 (셀러허브 등록명)"
          style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', flex: 1 }} />
        <input value={code} onChange={e => setCode(e.target.value)} placeholder="브랜드 코드"
          style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '120px' }} />
        <input value={aliases} onChange={e => setAliases(e.target.value)} placeholder="별칭(쉼표로 여러 개, 예: 해태제과,해태HAITAI)"
          style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', flex: 1.5 }} />
        <button onClick={addBrand} disabled={loading}
          style={{ fontSize: '12px', padding: '7px 16px', borderRadius: '8px', border: 'none', background: loading ? '#ccc' : '#1D9E75', color: '#fff', cursor: loading ? 'not-allowed' : 'pointer' }}>
          추가
        </button>
      </div>
      <div style={{ maxHeight: '300px', overflowY: 'auto', border: '0.5px solid #e8e8e8', borderRadius: '8px' }}>
        {brands.map(b => (
          <div key={b.id} style={{ padding: '8px 12px', borderBottom: '0.5px solid #f0f0f0' }}>
            {editingId === b.id ? (
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <span style={{ fontSize: '12px', flexShrink: 0 }}>{b.brand_name} ({b.brand_code})</span>
                <input autoFocus value={editAliases} onChange={e => setEditAliases(e.target.value)} placeholder="별칭(쉼표로 여러 개)"
                  style={{ fontSize: '12px', padding: '4px 8px', borderRadius: '6px', border: '0.5px solid #185FA5', flex: 1 }}
                  onKeyDown={e => { if (e.key === 'Enter') saveEdit(b); if (e.key === 'Escape') setEditingId(null); }} />
                <button onClick={() => saveEdit(b)} disabled={loading} style={{ fontSize: '11px', color: '#1D9E75', border: 'none', background: 'none', cursor: 'pointer' }}>저장</button>
                <button onClick={() => setEditingId(null)} style={{ fontSize: '11px', color: '#aaa', border: 'none', background: 'none', cursor: 'pointer' }}>취소</button>
              </div>
            ) : (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span onClick={() => startEdit(b)} style={{ fontSize: '12px', cursor: 'pointer' }}>
                  {b.brand_name} <span style={{ color: '#aaa' }}>({b.brand_code})</span>
                  {b.aliases ? (
                    <span style={{ color: '#185FA5', fontSize: '11px', marginLeft: '6px' }}>별칭: {b.aliases}</span>
                  ) : (
                    <span style={{ color: '#ccc', fontSize: '11px', marginLeft: '6px', borderBottom: '1px dashed #ccc' }}>별칭 추가</span>
                  )}
                </span>
                <button onClick={() => deleteBrand(b.id)} style={{ fontSize: '11px', color: '#A32D2D', border: 'none', background: 'none', cursor: 'pointer' }}>삭제</button>
              </div>
            )}
          </div>
        ))}
        {brands.length === 0 && <div style={{ padding: '16px', textAlign: 'center', color: '#aaa', fontSize: '12px' }}>등록된 브랜드가 없습니다</div>}
      </div>
    </Section>
  );
}


// [설계 원칙 - 2026-09-04] 마진율/수수료율/기준금액을 하드코딩 대신 여기서 직접 관리한다.
// 스마트스토어/11번가/지마켓·옥션은 "기준금액 이하/초과" 2단 구간 마진율을 쓰고,
// 셀러허브/쿠팡은 구간 없이 단일 마진율만 쓴다. 셀러허브는 엑셀 업로드 방식이라
// 즉시 반영 API가 없어 "가격 일괄 재계산+반영" 버튼을 제공하지 않는다.
// [기능 추가 - 2026-09-09] 지마켓/옥션은 마진율 "값"은 각각 따로 입력받지만,
// "가격 일괄 재계산+반영" 버튼은 기존처럼 ESM(지마켓+옥션) 통합으로 유지한다
// (계산 자체는 calcSalePrice가 이미 개별 판매처를 구분해서 처리하므로,
// 버튼을 굳이 나누지 않아도 각 상품이 정확한 마진율로 반영된다).
const MARGIN_PLATFORMS_TIERED = [
  { key: 'smartstore', label: '스마트스토어', platformCode: 'SMARTSTORE' },
  { key: 'elevenst', label: '11번가', platformCode: 'ELEVENST' },
  { key: 'gmarket', label: '지마켓', platformCode: 'GMARKET' },
  { key: 'auction', label: '옥션', platformCode: 'AUCTION' },
];
// 판매처별 "가격 일괄 재계산+반영" 팝업 - 관리코드 범위로 검색 후, 체크박스로 선택한 상품만 반영한다.
function MarginBulkApplyModal({ meta, onClose }) {
  const [codeFrom, setCodeFrom] = useState('');
  const [codeTo, setCodeTo] = useState('');
  const [products, setProducts] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [applying, setApplying] = useState(false);

  const fetchList = async () => {
    setLoading(true);
    try {
      const params = {};
      if (codeFrom) params.codeFrom = codeFrom;
      if (codeTo) params.codeTo = codeTo;
      const r = await api.get(`/products/margin-bulk-apply/${meta.platformCode}/list`, { params });
      setProducts(r.data || []);
      setSelectedIds((r.data || []).map(p => p.id));
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { fetchList(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleAll = () => {
    setSelectedIds(selectedIds.length === products.length ? [] : products.map(p => p.id));
  };
  const toggleOne = (id) => {
    setSelectedIds(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };
  const apply = async () => {
    if (selectedIds.length === 0) return alert('상품을 선택해주세요');
    setApplying(true);
    try {
      const res = await api.post(`/products/margin-bulk-apply/${meta.platformCode}`, { productIds: selectedIds });
      alert(`${res.data.updated}건 반영 완료 (실패 ${res.data.failed || 0}건)`);
      onClose();
    } catch (err) {
      alert('반영 실패: ' + (err.response?.data?.message || err.message));
    } finally {
      setApplying(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.4)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '12px', padding: '20px', width: '480px', maxHeight: '70vh', display: 'flex', flexDirection: 'column' }}>
        <div style={{ fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>{meta.label} 가격 일괄 재계산+반영</div>
        <div style={{ fontSize: '12px', color: '#888', marginBottom: '12px' }}>새 마진율을 적용할 상품을 선택하세요.</div>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
          <input value={codeFrom} onChange={e => setCodeFrom(e.target.value)} placeholder="관리코드 시작 (예: A0000000001)"
            style={{ flex: 1, fontSize: '13px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd' }} />
          <span style={{ alignSelf: 'center', color: '#aaa', fontSize: '13px' }}>~</span>
          <input value={codeTo} onChange={e => setCodeTo(e.target.value)} placeholder="관리코드 끝 (예: A0000000100)"
            style={{ flex: 1, fontSize: '13px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd' }} />
          <button onClick={fetchList} style={{ fontSize: '12px', padding: '7px 12px', borderRadius: '8px', border: '0.5px solid #ddd', background: '#fff', cursor: 'pointer' }}>검색</button>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 4px', borderBottom: '0.5px solid #eee' }}>
          <input type="checkbox" checked={selectedIds.length === products.length && products.length > 0} onChange={toggleAll} />
          <span style={{ fontSize: '12px', color: '#888' }}>전체 선택 ({products.length}건)</span>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', border: '0.5px solid #e8e8e8', borderRadius: '8px', margin: '8px 0', minHeight: '120px' }}>
          {loading ? (
            <div style={{ padding: '20px', textAlign: 'center', color: '#aaa', fontSize: '12px' }}>불러오는 중...</div>
          ) : products.length === 0 ? (
            <div style={{ padding: '20px', textAlign: 'center', color: '#aaa', fontSize: '12px' }}>전송완료된 상품이 없습니다</div>
          ) : (
            products.map(p => (
              <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 10px', borderBottom: '0.5px solid #f0f0f0' }}>
                <input type="checkbox" checked={selectedIds.includes(p.id)} onChange={() => toggleOne(p.id)} />
                <span style={{ fontSize: '12px', color: '#aaa', width: '100px', flexShrink: 0 }}>{p.product_code}</span>
                <span style={{ fontSize: '13px' }}>{p.name}</span>
              </div>
            ))
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '4px' }}>
          <button onClick={onClose} style={{ fontSize: '12px', padding: '7px 14px', borderRadius: '8px', border: '0.5px solid #ddd', background: '#fff', cursor: 'pointer' }}>취소</button>
          <button onClick={apply} disabled={applying}
            style={{ fontSize: '12px', padding: '7px 14px', borderRadius: '8px', border: 'none', background: applying ? '#ccc' : '#1D9E75', color: '#fff', cursor: applying ? 'not-allowed' : 'pointer' }}>
            {applying ? '반영 중...' : `선택 상품 반영 (${selectedIds.length}건)`}
          </button>
        </div>
      </div>
    </div>
  );
}
function MarginTierSection({ meta, values, onChange }) {
  const p = meta.key;
  const [showModal, setShowModal] = useState(false);
  return (
    <Section title={meta.label} desc="">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px', marginTop: '-40px' }}>
        <button onClick={() => setShowModal(true)}
          style={{ fontSize: '12px', padding: '6px 14px', borderRadius: '8px', border: '0.5px solid #ddd', background: '#fff', cursor: 'pointer' }}>
          가격 일괄 재계산+반영
        </button>
      </div>
      {showModal && <MarginBulkApplyModal meta={meta} onClose={() => setShowModal(false)} />}
      <div style={{ display: 'flex', gap: '12px' }}>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div style={{ background: '#E6F1FB', borderRadius: '8px', padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '6px' }}>
            <span style={{ fontSize: '13px', color: '#0C447C', display: 'flex', alignItems: 'center', gap: '6px' }}>
              기본가
              <input type="number" value={values[`margin_${p}_threshold`] || ''} onChange={e => onChange(`margin_${p}_threshold`, e.target.value)}
                style={{ width: '84px', textAlign: 'right', fontSize: '13px', padding: '4px 6px', borderRadius: '6px', border: '0.5px solid #ddd' }} />
              원 이하일 때
            </span>
            <span style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
              <input type="number" value={values[`margin_${p}_low_rate`] ? Math.round(values[`margin_${p}_low_rate`] * 100) : ''} onChange={e => onChange(`margin_${p}_low_rate`, e.target.value / 100)}
                style={{ width: '44px', textAlign: 'right', fontSize: '13px', padding: '4px 6px', borderRadius: '6px', border: '0.5px solid #ddd' }} />
              <span style={{ fontSize: '13px', color: '#888' }}>%</span>
            </span>
          </div>
          <div style={{ background: '#EEEDFE', borderRadius: '8px', padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '6px' }}>
            <span style={{ fontSize: '13px', color: '#3C3489', display: 'flex', alignItems: 'center', gap: '6px' }}>
              기본가
              <input type="number" value={values[`margin_${p}_threshold`] || ''} onChange={e => onChange(`margin_${p}_threshold`, e.target.value)}
                style={{ width: '84px', textAlign: 'right', fontSize: '13px', padding: '4px 6px', borderRadius: '6px', border: '0.5px solid #ddd' }} />
              원 초과일 때
            </span>
            <span style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
              <input type="number" value={values[`margin_${p}_high_rate`] ? Math.round(values[`margin_${p}_high_rate`] * 100) : ''} onChange={e => onChange(`margin_${p}_high_rate`, e.target.value / 100)}
                style={{ width: '44px', textAlign: 'right', fontSize: '13px', padding: '4px 6px', borderRadius: '6px', border: '0.5px solid #ddd' }} />
              <span style={{ fontSize: '13px', color: '#888' }}>%</span>
            </span>
          </div>
        </div>
        <div style={{ width: '1px', background: '#e8e8e8' }}></div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: '0 4px' }}>
          <span style={{ fontSize: '12px', color: '#888', marginBottom: '6px' }}>판매 수수료</span>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
            <input type="number" value={values[`margin_${p}_fee_rate`] ? Math.round(values[`margin_${p}_fee_rate`] * 100) : ''} onChange={e => onChange(`margin_${p}_fee_rate`, e.target.value / 100)}
              style={{ width: '44px', textAlign: 'right', fontSize: '13px', padding: '4px 6px', borderRadius: '6px', border: '0.5px solid #ddd' }} />
            <span style={{ fontSize: '13px' }}>%</span>
          </div>
        </div>
      </div>
    </Section>
  );
}
function MarginFlatSection({ platformKey, label, note, values, onChange }) {
  return (
    <Section title={label} desc={note}>
      <div style={{ display: 'flex', gap: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '13px', color: '#888' }}>마진율</span>
          <input type="number" value={values[`margin_${platformKey}_rate`] ? Math.round(values[`margin_${platformKey}_rate`] * 100) : ''} onChange={e => onChange(`margin_${platformKey}_rate`, e.target.value / 100)}
            style={{ width: '48px', textAlign: 'right', fontSize: '13px', padding: '4px 6px', borderRadius: '6px', border: '0.5px solid #ddd' }} />
          <span style={{ fontSize: '13px' }}>%</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ fontSize: '13px', color: '#888' }}>판매 수수료</span>
          <input type="number" value={values[`margin_${platformKey}_fee_rate`] ? Math.round(values[`margin_${platformKey}_fee_rate`] * 100) : ''} onChange={e => onChange(`margin_${platformKey}_fee_rate`, e.target.value / 100)}
            style={{ width: '48px', textAlign: 'right', fontSize: '13px', padding: '4px 6px', borderRadius: '6px', border: '0.5px solid #ddd' }} />
          <span style={{ fontSize: '13px' }}>%</span>
        </div>
      </div>
    </Section>
  );
}
function MarginSettingsSection() {
  const [values, setValues] = useState({});
  const [saveMsg, setSaveMsg] = useState('');

  const fetchValues = () => {
    api.get('/product-settings/margin-settings').then(r => {
      const parsed = {};
      Object.entries(r.data || {}).forEach(([k, v]) => { parsed[k] = parseFloat(v); });
      setValues(parsed);
    });
  };
  useEffect(() => { fetchValues(); }, []);

  const handleChange = (key, val) => {
    setValues(prev => ({ ...prev, [key]: parseFloat(val) || 0 }));
  };
  const handleSave = async () => {
    await api.post('/product-settings/margin-settings', values);
    setSaveMsg('저장되었습니다');
    setTimeout(() => setSaveMsg(''), 3000);
  };
  return (
    <div>
      <div style={{ fontSize: '12px', color: '#aaa', marginBottom: '8px' }}>
        판매처별 마진율/수수료율을 수정하고, 전송완료된 상품에 일괄 반영할 수 있습니다.
      </div>
      <div style={{ fontSize: '12px', color: '#E24B4A', marginBottom: '16px' }}>
        ⚠ 여기서 입력하는 마진율은 가격 계산 공식에 쓰이는 값이며, 상품등록 화면에 표시되는 실제 순마진(%)과는 다를 수 있습니다.
      </div>
      {MARGIN_PLATFORMS_TIERED.map(meta => (
        <MarginTierSection key={meta.key} meta={meta} values={values} onChange={handleChange} />
      ))}
      <MarginFlatSection platformKey="sellerhub" label="셀러허브" note="엑셀 업로드 방식이라 일괄 반영 버튼은 없습니다. 다음 엑셀 생성 시 새 값이 적용됩니다." values={values} onChange={handleChange} />
      <MarginFlatSection platformKey="coupang" label="쿠팡" note="" values={values} onChange={handleChange} />
      <MarginFlatSection platformKey="toss" label="토스쇼핑" note="" values={values} onChange={handleChange} />
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginTop: '12px' }}>
        <button onClick={handleSave} style={{ fontSize: '12px', padding: '8px 24px', borderRadius: '8px', border: 'none', background: '#1D9E75', color: '#fff', cursor: 'pointer', fontWeight: '500' }}>저장</button>
        {saveMsg && <span style={{ fontSize: '12px', color: '#1D9E75' }}>{saveMsg}</span>}
      </div>
    </div>
  );
}

// [기능 추가 - 2026-10-23] 상품그룹 관리: 이름(예: 001_xxxx)을 직접 입력해 추가/수정/삭제한다.
function ProductGroupSection({ showMsg }) {
  const [groups, setGroups] = useState([]);
  const [name, setName] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');
  const load = () => api.get('/product-settings/product-groups').then(r => setGroups(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);
  const errMsg = (e) => (e && e.response && e.response.data && e.response.data.message) || '오류가 발생했습니다';
  const inputStyle = { padding: '6px 10px', border: '0.5px solid #ccc', borderRadius: '6px', fontSize: '12px', width: '240px' };
  const btn = (bg, color, border) => ({ padding: '5px 12px', fontSize: '12px', borderRadius: '6px', cursor: 'pointer', background: bg, color, border: border || 'none' });
  const add = async () => {
    if (!name.trim()) return alert('그룹 이름을 입력해주세요');
    try { await api.post('/product-settings/product-groups', { name: name.trim() }); setName(''); showMsg('추가됐습니다'); load(); }
    catch (e) { alert(errMsg(e)); }
  };
  const saveEdit = async (id) => {
    if (!editName.trim()) return alert('그룹 이름을 입력해주세요');
    try { await api.put(`/product-settings/product-groups/${id}`, { name: editName.trim() }); setEditingId(null); showMsg('수정됐습니다'); load(); }
    catch (e) { alert(errMsg(e)); }
  };
  const remove = async (g) => {
    const warn = g.product_count > 0 ? `\n이 그룹의 상품 ${g.product_count}개는 미분류로 바뀝니다.` : '';
    if (!window.confirm(`"${g.name}" 그룹을 삭제하시겠습니까?${warn}`)) return;
    try { await api.delete(`/product-settings/product-groups/${g.id}`); showMsg('삭제됐습니다'); load(); }
    catch (e) { alert(errMsg(e)); }
  };
  return (
    <Section title="상품그룹 관리" desc="상품을 묶어서 보기 위한 그룹입니다. 이름은 직접 입력합니다 (예: 001_xxxx). 상품 등록·수정 화면에서 선택하고, 상품관리 검색에서 그룹별로 볼 수 있습니다">
      {groups.length === 0 && <div style={{ fontSize: '12px', color: '#aaa', fontStyle: 'italic', marginBottom: '16px' }}>등록된 그룹이 없습니다</div>}
      {groups.map(g => (
        <div key={g.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '8px 0', borderBottom: '0.5px solid #f0f0f0' }}>
          {editingId === g.id ? (
            <>
              <input style={inputStyle} value={editName} onChange={e => setEditName(e.target.value)} />
              <button style={btn('#1D9E75', '#fff')} onClick={() => saveEdit(g.id)}>저장</button>
              <button style={btn('#fff', '#666', '0.5px solid #ccc')} onClick={() => setEditingId(null)}>취소</button>
            </>
          ) : (
            <>
              <div style={{ flex: 1, fontSize: '13px', fontWeight: '500' }}>{g.name} <span style={{ fontSize: '11px', color: '#888', fontWeight: '400' }}>상품 {g.product_count}개</span></div>
              <button style={btn('#fff', '#666', '0.5px solid #ccc')} onClick={() => { setEditingId(g.id); setEditName(g.name); }}>수정</button>
              <button style={btn('#fff', '#A32D2D', '0.5px solid #e0b4b4')} onClick={() => remove(g)}>삭제</button>
            </>
          )}
        </div>
      ))}
      <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '16px', marginTop: '16px' }}>
        <div style={{ fontSize: '11px', fontWeight: '500', color: '#888', marginBottom: '10px' }}>새 그룹 추가</div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <input style={inputStyle} placeholder="예: 001_xxxx" value={name} onChange={e => setName(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') add(); }} />
          <button style={btn('#1D9E75', '#fff')} onClick={add}>추가</button>
        </div>
      </div>
    </Section>
  );
}

export default function Settings() {
  const [tab, setTab] = useState('cards');
  const [psForm, setPsForm] = useState({
    ps_naver_shipping_address_id: '', ps_naver_return_address_id: '',
    ps_naver_shipping_address_label: '', ps_naver_return_address_label: '',
    ps_as_phone: '', ps_as_guide: '',
    ps_delivery_fee_type: 'FREE', ps_base_fee: '', ps_free_conditional_amount: '',
    ps_return_fee: '', ps_exchange_fee: '', ps_delivery_company: '',
    ps_jeju_extra_fee: '', ps_free_return_insurance: 'false', ps_review_text_point: '', ps_review_photo_point: '',
    esm_outbound_location_code: '', esm_delivery_policy_no: '', esm_return_address_code: '',
    esm_auction_dispatch_policy: '', esm_gmarket_dispatch_policy: '', esm_delivery_method: '일반택배',
    esm_auction_dispatch_policy_3d: '-103', esm_auction_dispatch_policy_4d: '-104',
    esm_gmarket_dispatch_policy_3d: '-103', esm_gmarket_dispatch_policy_4d: '-104',
    eleven_addr_seq_out: '2', eleven_addr_seq_in: '3', eleven_rmaterial_typ_cd: '05',
    eleven_orgn_typ_cd: '03', eleven_send_close_tmplt_no: '4158518',
    eleven_send_close_tmplt_no_3d: '4195818', eleven_send_close_tmplt_no_4d: '4311107',
    toss_application_method_description: '', toss_application_term_description: '',
  });
  const [addressBooks, setAddressBooks] = useState([]);
  const [addrLoading, setAddrLoading] = useState(false);
  const [commonImages, setCommonImages] = useState([]);
  const [imgUploading, setImgUploading] = useState(false);
  const [naverPushing, setNaverPushing] = useState(false);

  const saveCommonImages = async (list) => {
    setCommonImages(list);
    await api.post('/product-settings', { ps_common_images: JSON.stringify(list) });
  };

  const handleCommonImageUpload = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = '';
    if (files.length === 0) return;
    if (commonImages.length + files.length > 6) return alert('최대 6장까지 등록할 수 있습니다.');
    setImgUploading(true);
    try {
      const fd = new FormData();
      files.forEach(f => fd.append('images', f));
      const r = await api.post('/product-settings/common-images/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      await saveCommonImages([...commonImages, ...r.data.files]);
      showMsg('업로드됐습니다');
    } catch(err) { alert('업로드 실패'); }
    finally { setImgUploading(false); }
  };

  const handleCommonImageReplace = async (idx, e) => {
    const file = e.target.files?.[0];
    e.target.value = '';
    if (!file) return;
    setImgUploading(true);
    try {
      const fd = new FormData();
      fd.append('images', file);
      const r = await api.post('/product-settings/common-images/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      const next = [...commonImages];
      next[idx] = r.data.files[0];
      await saveCommonImages(next);
      showMsg('교체됐습니다');
    } catch(err) { alert('교체 실패'); }
    finally { setImgUploading(false); }
  };

  const moveCommonImage = async (idx, dir) => {
    const t = idx + dir;
    if (t < 0 || t >= commonImages.length) return;
    const next = [...commonImages];
    [next[idx], next[t]] = [next[t], next[idx]];
    await saveCommonImages(next);
  };

  const removeCommonImage = async (idx) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    await saveCommonImages(commonImages.filter((_, i) => i !== idx));
  };

  const pushImagesToNaver = async () => {
    setNaverPushing(true);
    try {
      const r = await api.post('/product-settings/common-images/push-naver');
      setCommonImages(r.data.images || []);
      showMsg(r.data.message);
    } catch(err) { alert(err.response?.data?.message || '네이버 업로드 실패'); }
    finally { setNaverPushing(false); }
  };

  const [psSaveMsg, setPsSaveMsg] = useState('');
  const [psSavedAt, setPsSavedAt] = useState(null);
  const [catSyncing, setCatSyncing] = useState(false);
  const [catMatching, setCatMatching] = useState(false);
  const [catSyncMsg, setCatSyncMsg] = useState('');
  const [catMatchResult, setCatMatchResult] = useState(null);
  const [showUnmatched, setShowUnmatched] = useState(false);
  const [unmatchedList, setUnmatchedList] = useState([]);
  const [unmatchedLoading, setUnmatchedLoading] = useState(false);

  const loadUnmatched = async () => {
    setUnmatchedLoading(true);
    try {
      const r = await api.get('/product-settings/naver/categories/unmatched');
      setUnmatchedList(r.data);
      setShowUnmatched(true);
    } catch(err) { alert('조회 실패'); }
    finally { setUnmatchedLoading(false); }
  };

  const applyManualMatch = async (categoryId, naverCategoryId) => {
    await api.post('/product-settings/naver/categories/manual-match', { categoryId, naverCategoryId });
    setUnmatchedList(prev => prev.filter(c => c.id !== categoryId));
  };

  const syncNaverCategories = async () => {
    setCatSyncing(true);
    setCatSyncMsg('');
    try {
      const r = await api.post('/product-settings/naver/categories/sync');
      setCatSyncMsg(r.data.message);
    } catch(err) { alert(err.response?.data?.message || '동기화 실패'); }
    finally { setCatSyncing(false); }
  };

  const runAutoMatch = async () => {
    setCatMatching(true);
    setCatMatchResult(null);
    try {
      const r = await api.post('/product-settings/naver/categories/auto-match');
      setCatMatchResult(r.data);
    } catch(err) { alert(err.response?.data?.message || '자동 매칭 실패'); }
    finally { setCatMatching(false); }
  };

  const loadProductSettings = async () => {
    try {
      const r = await api.get('/product-settings');
      setPsForm(prev => ({ ...prev, ...r.data }));
      setPsSavedAt(r.data._updated_at || null);
      try { setCommonImages(JSON.parse(r.data.ps_common_images || '[]')); } catch(e) { setCommonImages([]); }
    } catch(e) { console.error(e); }
  };

  const loadAddressBooks = async () => {
    setAddrLoading(true);
    try {
      const r = await api.get('/product-settings/naver/addressbooks');
      setAddressBooks(r.data.addressBooks || []);
      showMsg(`주소록 ${(r.data.addressBooks||[]).length}건을 불러왔습니다`);
    } catch(e) {
      alert('주소록 조회 실패: ' + (e.response?.data?.message || e.message));
    } finally { setAddrLoading(false); }
  };
  const [blacklist, setBlacklist] = useState([]);
  const [blName, setBlName] = useState('');
  const [blAddress, setBlAddress] = useState('');
  const [blPhone, setBlPhone] = useState('');
  const [blReason, setBlReason] = useState('');
  const [editingBl, setEditingBl] = useState(null);
  const [editBlName, setEditBlName] = useState('');
  const [editBlAddress, setEditBlAddress] = useState('');
  const [editBlPhone, setEditBlPhone] = useState('');
  const [editBlReason, setEditBlReason] = useState('');

  const loadBlacklist = async () => {
    try { const r = await api.get('/blacklist'); setBlacklist(r.data); } catch(e) { console.error(e); }
  };
  const [cards, setCards] = useState([]);
  const [platforms, setPlatforms] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [msg, setMsg] = useState('');

  const [cardName, setCardName] = useState('');
  const [cardCompany, setCardCompany] = useState('');
  const [platformName, setPlatformName] = useState('');
  const [accountId, setAccountId] = useState('');
  const [accountName, setAccountName] = useState('');

  const [editingCard, setEditingCard] = useState(null);
  const [editCardName, setEditCardName] = useState('');
  const [editCardCompany, setEditCardCompany] = useState('');

  const [editingCode, setEditingCode] = useState(null);
  const [editCodeVal, setEditCodeVal] = useState('');
  const [editPlatformName, setEditPlatformName] = useState('');

  const [editingAccount, setEditingAccount] = useState(null);
  const [couriers, setCouriers] = useState([]);
  const [newCourierName, setNewCourierName] = useState('');
  const [newCourierCode, setNewCourierCode] = useState('');
  const [editCourierId, setEditCourierId] = useState(null);
  const [editCourierName, setEditCourierName] = useState('');
  const [editCourierCode, setEditCourierCode] = useState('');
  const [editCourierElevenCode, setEditCourierElevenCode] = useState('');
  const [editCourierNaverCode, setEditCourierNaverCode] = useState('');
  const [editCourierCoupangCode, setEditCourierCoupangCode] = useState('');
  const [newCourierCoupangCode, setNewCourierCoupangCode] = useState('');
  const [editCourierSellerhubCode, setEditCourierSellerhubCode] = useState('');
  const [newCourierSellerhubCode, setNewCourierSellerhubCode] = useState('');
  const [editCourierEsmCode, setEditCourierEsmCode] = useState('');
  const [editCourierTossCode, setEditCourierTossCode] = useState('');
  const [newCourierEsmCode, setNewCourierEsmCode] = useState('');
  const [newCourierTossCode, setNewCourierTossCode] = useState('');
  const [newCourierElevenCode, setNewCourierElevenCode] = useState('');
  const [newCourierNaverCode, setNewCourierNaverCode] = useState('');
  const loadCouriers = async () => {
    try { const r = await api.get('/couriers'); setCouriers(r.data); } catch(e) { console.error(e); }
  };
  const [editAccountId, setEditAccountId] = useState('');
  const [editAccountName, setEditAccountName] = useState('');

  const [trackerClientId, setTrackerClientId] = useState('');
  const [trackerClientSecret, setTrackerClientSecret] = useState('');
  const [trackerExpiry, setTrackerExpiry] = useState(null);
  const [trackerDaysLeft, setTrackerDaysLeft] = useState(null);

  const loadTracker = async () => {
    try {
      const r = await api.get('/orders/tracker-credentials');
      setTrackerClientId(r.data.client_id || '');
      setTrackerClientSecret(r.data.client_secret ? '●●●●●●●●●●●●●●●●●●●●' : '');
      setTrackerExpiry(r.data.expiry);
      if (r.data.expiry) {
        const diff = new Date(r.data.expiry) - new Date();
        setTrackerDaysLeft(Math.ceil(diff / (1000 * 60 * 60 * 24)));
      }
    } catch(e) { console.error(e); }
  };

  const showMsg = (m) => { setMsg(m); setTimeout(() => setMsg(''), 2000); };

  const fetchAll = async () => {
    try {
      const [c, p, a] = await Promise.all([
        api.get('/cards'),
        api.get('/purchase-platforms'),
        api.get('/purchase-accounts'),
      ]);
      setCards(c.data);
      setPlatforms(p.data);
      setAccounts(a.data);
    } catch (err) { console.error(err); }
  };

  useEffect(() => { fetchAll(); loadCouriers(); loadTracker(); loadBlacklist(); loadProductSettings(); }, []);

  const addBtn = { fontSize: '12px', padding: '7px 16px', borderRadius: '8px', border: 'none', background: '#1D9E75', color: '#fff', cursor: 'pointer' };
  const delBtn = { fontSize: '11px', padding: '4px 10px', borderRadius: '6px', border: '0.5px solid #ffcdd2', background: 'none', color: '#e53935', cursor: 'pointer' };
  const editBtn = { fontSize: '11px', padding: '4px 10px', borderRadius: '6px', border: '0.5px solid #ddd', background: 'none', color: '#888', cursor: 'pointer' };
  const saveBtn = { fontSize: '11px', padding: '4px 10px', borderRadius: '6px', border: 'none', background: '#1D9E75', color: '#fff', cursor: 'pointer' };
  const cancelBtn = { fontSize: '11px', padding: '4px 10px', borderRadius: '6px', border: '0.5px solid #ddd', background: 'none', color: '#888', cursor: 'pointer' };
  const inp = (placeholder, value, onChange, width) => (
    <input value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
      style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: width || '160px' }} />
  );
  const editInp = (value, onChange, width) => (
    <input value={value} onChange={e => onChange(e.target.value)}
      style={{ fontSize: '11px', padding: '4px 8px', borderRadius: '6px', border: '0.5px solid #1D9E75', width: width || '140px' }} />
  );

  const itemStyle = { padding: '10px 14px', background: '#f5f5f5', borderRadius: '8px', border: '0.5px solid #e8e8e8', marginBottom: '8px' };

  const tabs = [
    { key: 'cards', label: '카드 관리' },
    { key: 'platforms', label: '구매처 관리' },
    { key: 'accounts', label: '구매 아이디 관리' },
    { key: 'couriers', label: '택배사 관리' },
    { key: 'tracker', label: 'API 관리' },
    { key: 'blacklist', label: '블랙리스트 관리' },
    { key: 'productSettings', label: '상품등록 설정' },
    { key: 'productGroups', label: '상품그룹 관리' },
    { key: 'marginSettings', label: '마진율 관리' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '15px', fontWeight: '500', margin: 0 }}>설정</h1>
        {msg && <span style={{ fontSize: '12px', color: '#1D9E75' }}>{msg}</span>}
      </div>

      <div style={{ display: 'flex', marginBottom: '16px', borderBottom: '0.5px solid #e8e8e8' }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '8px 18px', fontSize: '12px', border: 'none', background: 'none', cursor: 'pointer',
            color: tab === t.key ? '#1a1a1a' : '#888', fontWeight: tab === t.key ? '500' : '400',
            borderBottom: tab === t.key ? '2px solid #1D9E75' : '2px solid transparent', marginBottom: '-0.5px'
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'cards' && (
        <Section title="카드 관리" desc="등록한 카드는 주문 관리 구매기록에서 드롭다운으로 선택할 수 있습니다">
          {cards.length === 0 && <div style={{ fontSize: '12px', color: '#aaa', fontStyle: 'italic', marginBottom: '16px' }}>등록된 카드가 없습니다</div>}
          {cards.map(card => (
            <div key={card.id} style={itemStyle}>
              {editingCard === card.id ? (
                <div>
                  <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}>
                    {editInp(editCardName, setEditCardName, '150px')}
                    {editInp(editCardCompany, setEditCardCompany, '130px')}
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button style={saveBtn} onClick={async () => {
                      await api.patch(`/cards/${card.id}`, { card_name: editCardName, card_company: editCardCompany });
                      setEditingCard(null); showMsg('수정됐습니다'); fetchAll();
                    }}>저장</button>
                    <button style={cancelBtn} onClick={() => setEditingCard(null)}>취소</button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: '500' }}>{card.card_name}</div>
                    {card.card_company && <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>{card.card_company}</div>}
                  </div>
                  <button style={editBtn} onClick={() => { setEditingCard(card.id); setEditCardName(card.card_name); setEditCardCompany(card.card_company || ''); }}>수정</button>
                  <button style={delBtn} onClick={async () => {
                    if (!window.confirm('삭제하시겠습니까?')) return;
                    await api.delete(`/cards/${card.id}`); showMsg('삭제됐습니다'); fetchAll();
                  }}>삭제</button>
                </div>
              )}
            </div>
          ))}
          <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '16px' }}>
            <div style={{ fontSize: '11px', fontWeight: '500', color: '#888', marginBottom: '10px' }}>새 카드 추가</div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
              {inp('카드명 (예: 현대0000)', cardName, setCardName, '160px')}
              {inp('카드사 (예: 현대카드)', cardCompany, setCardCompany, '140px')}
              <button style={addBtn} onClick={async () => {
                if (!cardName.trim()) return;
                await api.post('/cards', { card_name: cardName, card_company: cardCompany });
                setCardName(''); setCardCompany(''); showMsg('추가됐습니다'); fetchAll();
              }}>추가</button>
            </div>
          </div>
        </Section>
      )}

      {tab === 'platforms' && (
        <Section title="구매처 관리" desc="한글명만 입력하면 코드가 자동 생성됩니다. 수정 버튼으로 이름과 코드를 변경할 수 있습니다">
          {platforms.length === 0 && <div style={{ fontSize: '12px', color: '#aaa', fontStyle: 'italic', marginBottom: '16px' }}>등록된 구매처가 없습니다</div>}
          {platforms.map(p => (
            <div key={p.id} style={itemStyle}>
              {editingCode === p.id ? (
                <div>
                  <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}>
                    {editInp(editPlatformName, setEditPlatformName, '150px')}
                    {editInp(editCodeVal, setEditCodeVal, '130px')}
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button style={saveBtn} onClick={async () => {
                      await api.patch(`/purchase-platforms/${p.id}`, { name_kr: editPlatformName, code: editCodeVal });
                      setEditingCode(null); showMsg('수정됐습니다'); fetchAll();
                    }}>저장</button>
                    <button style={cancelBtn} onClick={() => setEditingCode(null)}>취소</button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: '500' }}>{p.name_kr}</div>
                    <div style={{ marginTop: '4px' }}>
                      <span style={{ fontSize: '10px', padding: '2px 8px', borderRadius: '4px', background: '#E6F1FB', color: '#185FA5', border: '0.5px solid #B5D4F4' }}>{p.code}</span>
                    </div>
                  </div>
                  <button style={editBtn} onClick={() => { setEditingCode(p.id); setEditPlatformName(p.name_kr); setEditCodeVal(p.code); }}>수정</button>
                  <button style={delBtn} onClick={async () => {
                    if (!window.confirm('삭제하시겠습니까?')) return;
                    await api.delete(`/purchase-platforms/${p.id}`); showMsg('삭제됐습니다'); fetchAll();
                  }}>삭제</button>
                </div>
              )}
            </div>
          ))}
          <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '16px' }}>
            <div style={{ fontSize: '11px', fontWeight: '500', color: '#888', marginBottom: '10px' }}>새 구매처 추가</div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
              {inp('구매처 한글명 (예: 네이버쇼핑)', platformName, setPlatformName, '220px')}
              <button style={addBtn} onClick={async () => {
                if (!platformName.trim()) return;
                await api.post('/purchase-platforms', { name_kr: platformName });
                setPlatformName(''); showMsg('추가됐습니다'); fetchAll();
              }}>추가</button>
            </div>
            <div style={{ fontSize: '11px', color: '#aaa', marginTop: '8px' }}>코드는 한글명 기반으로 자동 생성됩니다. 필요시 수정 가능합니다.</div>
          </div>
        </Section>
      )}

      {tab === 'accounts' && (
        <Section title="구매 아이디 관리" desc="아이디와 이름을 등록합니다 (예: ruddn6808 / 한경우(네이버))">
          {accounts.length === 0 && <div style={{ fontSize: '12px', color: '#aaa', fontStyle: 'italic', marginBottom: '16px' }}>등록된 아이디가 없습니다</div>}
          {accounts.map(a => (
            <div key={a.id} style={itemStyle}>
              {editingAccount === a.id ? (
                <div>
                  <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}>
                    {editInp(editAccountId, setEditAccountId, '150px')}
                    {editInp(editAccountName, setEditAccountName, '170px')}
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button style={saveBtn} onClick={async () => {
                      await api.patch(`/purchase-accounts/${a.id}`, { account_id: editAccountId, account_name: editAccountName });
                      setEditingAccount(null); showMsg('수정됐습니다'); fetchAll();
                    }}>저장</button>
                    <button style={cancelBtn} onClick={() => setEditingAccount(null)}>취소</button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{ fontSize: '13px', fontWeight: '500' }}>{a.account_id}</div>
                    <div style={{ fontSize: '11px', color: '#888' }}>{a.account_name}</div>
                  </div>
                  <button style={editBtn} onClick={() => { setEditingAccount(a.id); setEditAccountId(a.account_id); setEditAccountName(a.account_name); }}>수정</button>
                  <button style={delBtn} onClick={async () => {
                    if (!window.confirm('삭제하시겠습니까?')) return;
                    await api.delete(`/purchase-accounts/${a.id}`); showMsg('삭제됐습니다'); fetchAll();
                  }}>삭제</button>
                </div>
              )}
            </div>
          ))}
          <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '16px' }}>
            <div style={{ fontSize: '11px', fontWeight: '500', color: '#888', marginBottom: '10px' }}>새 아이디 추가</div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
              {inp('아이디 (예: ruddn6808)', accountId, setAccountId, '160px')}
              {inp('이름 (예: 한경우(네이버))', accountName, setAccountName, '180px')}
              <button style={addBtn} onClick={async () => {
                if (!accountId.trim() || !accountName.trim()) return;
                await api.post('/purchase-accounts', { account_id: accountId, account_name: accountName });
                setAccountId(''); setAccountName(''); showMsg('추가됐습니다'); fetchAll();
              }}>추가</button>
            </div>
          </div>
        </Section>
      )}
      {tab === 'couriers' && (
        <Section title="택배사 관리" desc="택배사를 등록합니다. 코드는 내부 식별용입니다 (예: CJ대한통운 / CJ)">
          {couriers.length === 0 && <div style={{ fontSize: '12px', color: '#aaa', fontStyle: 'italic', marginBottom: '16px' }}>등록된 택배사가 없습니다</div>}
          {couriers.map(c => (
            <div key={c.id} style={itemStyle}>
              {editCourierId === c.id ? (
                <div>
                  <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}>
                    {editInp(editCourierName, setEditCourierName, '150px')}
                    <input value={editCourierCode} onChange={e => setEditCourierCode(e.target.value.toUpperCase())} onPaste={e => { e.preventDefault(); setEditCourierCode((e.clipboardData.getData('text')).toUpperCase()); }} style={{ fontSize: '11px', padding: '4px 8px', borderRadius: '6px', border: '0.5px solid #1D9E75', width: '100px' }} placeholder="코드" />
                    <input value={editCourierElevenCode} onChange={e => setEditCourierElevenCode(e.target.value)} style={{ fontSize: '11px', padding: '4px 8px', borderRadius: '6px', border: '0.5px solid #EF9F27', width: '100px' }} placeholder="11번가 코드" />
                    <input value={editCourierNaverCode} onChange={e => setEditCourierNaverCode(e.target.value)} style={{ fontSize: '11px', padding: '4px 8px', borderRadius: '6px', border: '0.5px solid #1D9E75', width: '100px' }} placeholder="스마트스토어 코드" />
                    <input value={editCourierCoupangCode} onChange={e => setEditCourierCoupangCode(e.target.value)} style={{ fontSize: '11px', padding: '4px 8px', borderRadius: '6px', border: '0.5px solid #378ADD', width: '100px' }} placeholder="쿠팡 코드" />
                    <input value={editCourierSellerhubCode} onChange={e => setEditCourierSellerhubCode(e.target.value)} style={{ fontSize: '11px', padding: '4px 8px', borderRadius: '6px', border: '0.5px solid #7F77DD', width: '100px' }} placeholder="셀러허브 코드" />
                    <input value={editCourierEsmCode} onChange={e => setEditCourierEsmCode(e.target.value)} style={{ fontSize: '11px', padding: '4px 8px', borderRadius: '6px', border: '0.5px solid #D85A30', width: '100px' }} placeholder="ESM 코드" />
                    <input value={editCourierTossCode} onChange={e => setEditCourierTossCode(e.target.value)} style={{ fontSize: '11px', padding: '4px 8px', borderRadius: '6px', border: '0.5px solid #0064FF', width: '100px' }} placeholder="토스쇼핑 코드" />
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button style={saveBtn} onClick={async () => {
                      await api.patch(`/couriers/${c.id}`, { name: editCourierName, code: editCourierCode, eleven_code: editCourierElevenCode, naver_code: editCourierNaverCode, coupang_code: editCourierCoupangCode, sellerhub_code: editCourierSellerhubCode, esm_code: editCourierEsmCode, toss_code: editCourierTossCode });
                      setEditCourierId(null); showMsg('수정됐습니다'); loadCouriers();
                    }}>저장</button>
                    <button style={cancelBtn} onClick={() => setEditCourierId(null)}>취소</button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ flex: 1, display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                    <div style={{ fontSize: '13px', fontWeight: '500' }}>{c.name}</div>
                    <div style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '4px', background: '#E6F1FB', color: '#185FA5', border: '0.5px solid #B5D4F4' }}>{c.code}</div>
                    {c.eleven_code && <div style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '4px', background: '#FAEEDA', color: '#854F0B', border: '0.5px solid #EF9F27' }}>11번가: {c.eleven_code}</div>}
                    {c.naver_code && <div style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '4px', background: '#E1F5EE', color: '#0F6E56', border: '0.5px solid #1D9E75' }}>스마트스토어: {c.naver_code}</div>}
                    {c.coupang_code && <div style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '4px', background: '#E6F1FB', color: '#185FA5', border: '0.5px solid #378ADD' }}>쿠팡: {c.coupang_code}</div>}
                    {c.sellerhub_code && <div style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '4px', background: '#EEEDFE', color: '#3C3489', border: '0.5px solid #7F77DD' }}>셀러허브: {c.sellerhub_code}</div>}
                    {c.esm_code && <div style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '4px', background: '#FAECE7', color: '#993C1D', border: '0.5px solid #D85A30' }}>ESM: {c.esm_code}</div>}
                    {c.toss_code && <div style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '4px', background: '#E6EEFF', color: '#0040B0', border: '0.5px solid #0064FF' }}>토스쇼핑: {c.toss_code}</div>}
                  </div>
                  <button style={editBtn} onClick={() => { setEditCourierId(c.id); setEditCourierName(c.name); setEditCourierCode(c.code); setEditCourierElevenCode(c.eleven_code || ''); setEditCourierNaverCode(c.naver_code || ''); setEditCourierCoupangCode(c.coupang_code || ''); setEditCourierSellerhubCode(c.sellerhub_code || ''); setEditCourierEsmCode(c.esm_code || ''); setEditCourierTossCode(c.toss_code || ''); }}>수정</button>
                  <button style={delBtn} onClick={async () => {
                    if (!window.confirm('삭제하시겠습니까?')) return;
                    await api.delete(`/couriers/${c.id}`); showMsg('삭제됐습니다'); loadCouriers();
                  }}>삭제</button>
                </div>
              )}
            </div>
          ))}
          <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '16px' }}>
            <div style={{ fontSize: '11px', fontWeight: '500', color: '#888', marginBottom: '10px' }}>새 택배사 추가</div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
              {inp('택배사명 (예: CJ대한통운)', newCourierName, setNewCourierName, '180px')}
              <input value={newCourierCode} onChange={e => setNewCourierCode(e.target.value.toUpperCase())} onPaste={e => { e.preventDefault(); setNewCourierCode((e.clipboardData.getData('text')).toUpperCase()); }} placeholder='코드 (예: CJ)' style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '90px' }} />
              <input value={newCourierElevenCode} onChange={e => setNewCourierElevenCode(e.target.value)} placeholder='11번가 코드' style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #EF9F27', width: '100px' }} />
              <input value={newCourierNaverCode} onChange={e => setNewCourierNaverCode(e.target.value)} placeholder='스마트스토어 코드' style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #1D9E75', width: '130px' }} />
              <input value={newCourierCoupangCode} onChange={e => setNewCourierCoupangCode(e.target.value)} placeholder='쿠팡 코드' style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #378ADD', width: '100px' }} />
              <input value={newCourierSellerhubCode} onChange={e => setNewCourierSellerhubCode(e.target.value)} placeholder='셀러허브 코드' style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #7F77DD', width: '100px' }} />
              <input value={newCourierEsmCode} onChange={e => setNewCourierEsmCode(e.target.value)} placeholder='ESM 코드' style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #D85A30', width: '100px' }} />
            <input value={newCourierTossCode} onChange={e => setNewCourierTossCode(e.target.value)} placeholder='토스쇼핑 코드' style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #0064FF', width: '100px' }} />
              <button style={addBtn} onClick={async () => {
                if (!newCourierName.trim() || !newCourierCode.trim()) return;
                await api.post('/couriers', { name: newCourierName, code: newCourierCode, eleven_code: newCourierElevenCode, naver_code: newCourierNaverCode, coupang_code: newCourierCoupangCode, sellerhub_code: newCourierSellerhubCode, esm_code: newCourierEsmCode, toss_code: newCourierTossCode });
                setNewCourierName(''); setNewCourierCode(''); setNewCourierElevenCode(''); setNewCourierNaverCode(''); setNewCourierCoupangCode(''); showMsg('추가됐습니다'); loadCouriers();
              }}>추가</button>
            </div>
          </div>
        </Section>
      )}
      {tab === 'tracker' && (
        <div>
          <Section title="스마트스토어 API" desc="네이버 커머스 API 인증 정보">
            <div style={{ padding: '10px 14px', background: '#f5f5f5', borderRadius: '8px', fontSize: '12px', color: '#888' }}>
              네이버 커머스 API 인증정보는 서버 환경변수(.env)에 저장되어 있습니다. 변경이 필요한 경우 관리자에게 문의하세요.
            </div>
          </Section>

          <Section title="11번가 API" desc="11번가 오픈 API 키">
            <div style={{ padding: '10px 14px', background: '#f5f5f5', borderRadius: '8px', fontSize: '12px', color: '#888' }}>
              11번가 API 키는 서버 환경변수(.env)에 저장되어 있습니다. 변경이 필요한 경우 관리자에게 문의하세요.
            </div>
          </Section>

          <CoupangApiSection showMsg={showMsg} />

          <Section title="배송추적 API" desc="tracker.delivery API 키를 관리합니다. 21일마다 재발급 후 갱신하세요.">
            <div style={{ marginBottom: '20px' }}>
              <div style={{ fontSize: '11px', fontWeight: '500', color: '#888', marginBottom: '10px' }}>API 키 설정</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '500px' }}>
                <div>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>Client Id</div>
                  <input value={trackerClientId} onChange={e => setTrackerClientId(e.target.value)}
                    placeholder="Client Id 입력"
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>Client Secret</div>
                  <input value={trackerClientSecret} onChange={e => setTrackerClientSecret(e.target.value)}
                    placeholder="Client Secret 입력"
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                </div>
                <button onClick={async () => {
                  if (!trackerClientId.trim() || !trackerClientSecret.trim()) return alert('Client Id와 Client Secret을 입력해주세요.');
                  if (trackerClientSecret.includes('●')) return alert('Client Secret을 새로 입력해주세요.');
                  await api.post('/orders/tracker-credentials', { client_id: trackerClientId, client_secret: trackerClientSecret });
                  showMsg('저장됐습니다');
                  loadTracker();
                }} style={{ fontSize: '12px', padding: '8px 20px', borderRadius: '8px', border: 'none', background: '#1D9E75', color: '#fff', cursor: 'pointer', fontWeight: '500', alignSelf: 'flex-start' }}>저장</button>
              </div>
            </div>
            <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '16px' }}>
              <div style={{ fontSize: '11px', fontWeight: '500', color: '#888', marginBottom: '10px' }}>만료일 관리</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <span style={{ fontSize: '12px', color: trackerDaysLeft !== null && trackerDaysLeft <= 3 ? '#854F0B' : '#444' }}>
                  {trackerExpiry ? `만료일: ${trackerExpiry} (D-${trackerDaysLeft <= 0 ? 'day' : trackerDaysLeft})` : '만료일 미설정'}
                </span>
                <button onClick={async () => {
                  if (!window.confirm('tracker.delivery API 키를 재발급 받으셨나요?\n오늘부터 21일 후로 만료일이 갱신됩니다.')) return;
                  await api.post('/orders/tracker-expiry/renew');
                  showMsg('만료일이 갱신됐습니다');
                  loadTracker();
                }} style={{ fontSize: '12px', padding: '6px 16px', borderRadius: '8px', border: '0.5px solid #185FA5', background: '#E6F1FB', color: '#185FA5', cursor: 'pointer' }}>🔑 배송 API 갱신</button>
              </div>
              {trackerDaysLeft !== null && trackerDaysLeft <= 3 && (
                <div style={{ marginTop: '10px', padding: '10px 14px', background: '#FAEEDA', borderRadius: '8px', fontSize: '12px', color: '#854F0B' }}>
                  ⚠️ API 키가 {trackerDaysLeft <= 0 ? '만료됐습니다!' : `${trackerDaysLeft}일 후 만료됩니다.`} tracker.delivery에서 재발급 후 위에서 새 키를 저장하고 갱신 버튼을 눌러주세요.
                </div>
              )}
            </div>
          </Section>
        </div>
      )}

      {tab === 'blacklist' && (
        <Section title="블랙리스트 관리" desc="이름과 주소(시/구까지)가 일치하는 주문을 주문관리에서 표시합니다">
          {blacklist.length === 0 && <div style={{ fontSize: '12px', color: '#aaa', fontStyle: 'italic', marginBottom: '16px' }}>등록된 블랙리스트가 없습니다</div>}
          {blacklist.map(b => (
            <div key={b.id} style={itemStyle}>
              {editingBl === b.id ? (
                <div>
                  <div style={{ display: 'flex', gap: '6px', marginBottom: '8px', flexWrap: 'wrap' }}>
                    {editInp(editBlName, setEditBlName, '120px')}
                    {editInp(editBlAddress, setEditBlAddress, '200px')}
                    {editInp(editBlPhone, setEditBlPhone, '140px')}
                    {editInp(editBlReason, setEditBlReason, '200px')}
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button style={saveBtn} onClick={async () => {
                      await api.patch(`/blacklist/${b.id}`, { name: editBlName, address: editBlAddress, phone: editBlPhone, reason: editBlReason });
                      setEditingBl(null); showMsg('수정됐습니다'); loadBlacklist();
                    }}>저장</button>
                    <button style={cancelBtn} onClick={() => setEditingBl(null)}>취소</button>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '13px', fontWeight: '500' }}>{b.name}</div>
                    <div style={{ fontSize: '11px', color: '#888', marginTop: '2px' }}>{b.address} · {b.phone}</div>
                    {b.reason && <div style={{ fontSize: '11px', color: '#A32D2D', marginTop: '2px' }}>사유: {b.reason}</div>}
                  </div>
                  <button style={editBtn} onClick={() => { setEditingBl(b.id); setEditBlName(b.name); setEditBlAddress(b.address); setEditBlPhone(b.phone || ''); setEditBlReason(b.reason || ''); }}>수정</button>
                  <button style={delBtn} onClick={async () => {
                    if (!window.confirm('삭제하시겠습니까?')) return;
                    await api.delete(`/blacklist/${b.id}`); showMsg('삭제됐습니다'); loadBlacklist();
                  }}>삭제</button>
                </div>
              )}
            </div>
          ))}
          <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '16px' }}>
            <div style={{ fontSize: '11px', fontWeight: '500', color: '#888', marginBottom: '10px' }}>새 블랙리스트 추가</div>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
              {inp('이름', blName, setBlName, '120px')}
              {inp('주소 (예: 서울특별시 강남구)', blAddress, setBlAddress, '220px')}
              {inp('전화번호', blPhone, setBlPhone, '140px')}
              {inp('사유', blReason, setBlReason, '200px')}
              <button style={addBtn} onClick={async () => {
                if (!blName.trim() || !blAddress.trim() || !blPhone.trim()) return alert('이름, 주소, 전화번호는 필수입니다');
                await api.post('/blacklist', { name: blName, address: blAddress, phone: blPhone, reason: blReason });
                setBlName(''); setBlAddress(''); setBlPhone(''); setBlReason(''); showMsg('추가됐습니다'); loadBlacklist();
              }}>추가</button>
            </div>
            <div style={{ fontSize: '11px', color: '#aaa', marginTop: '8px' }}>주소는 시/구까지만 입력하세요 (예: 서울특별시 강남구). 상세주소는 비교하지 않습니다. 이름+주소+전화번호가 모두 일치해야 블랙리스트로 표시됩니다.</div>
          </div>
        </Section>
      )}

      {tab === 'productSettings' && (
        <div>
          <Section title="공통 설정" desc="모든 판매처에 공통으로 적용되는 상품등록 기본값입니다">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxWidth: '560px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <div>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>A/S 전화번호</div>
                  <input value={psForm.ps_as_phone} onChange={e => setPsForm(p=>({...p, ps_as_phone: e.target.value}))} placeholder="예: 010-0000-0000"
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>택배사</div>
                  <select value={psForm.ps_delivery_company} onChange={e => setPsForm(p=>({...p, ps_delivery_company: e.target.value}))}
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', background: '#fff' }}>
                    <option value="">--선택--</option>
                    {couriers.map(c => <option key={c.id} value={c.code}>{c.name}</option>)}
                  </select>
                </div>
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>A/S 안내</div>
                <textarea value={psForm.ps_as_guide} onChange={e => setPsForm(p=>({...p, ps_as_guide: e.target.value}))} placeholder="A/S 안내 문구를 입력하세요"
                  style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', minHeight: '60px', resize: 'vertical', boxSizing: 'border-box', lineHeight: '1.6' }} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px' }}>
                <div>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>배송비 유형</div>
                  <select value={psForm.ps_delivery_fee_type} onChange={e => setPsForm(p=>({...p, ps_delivery_fee_type: e.target.value}))}
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', background: '#fff' }}>
                    <option value="FREE">무료</option>
                    <option value="PAID">유료</option>
                    <option value="CONDITIONAL_FREE">조건부 무료</option>
                  </select>
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>기본 배송비</div>
                  <input value={psForm.ps_base_fee} onChange={e => setPsForm(p=>({...p, ps_base_fee: e.target.value.replace(/[^0-9]/g,'')}))} placeholder="0"
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>무료 조건 금액</div>
                  <input value={psForm.ps_free_conditional_amount} onChange={e => setPsForm(p=>({...p, ps_free_conditional_amount: e.target.value.replace(/[^0-9]/g,'')}))} placeholder="0"
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                <div>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>반품 배송비</div>
                  <input value={psForm.ps_return_fee} onChange={e => setPsForm(p=>({...p, ps_return_fee: e.target.value.replace(/[^0-9]/g,'')}))} placeholder="0"
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>교환 배송비</div>
                  <input value={psForm.ps_exchange_fee} onChange={e => setPsForm(p=>({...p, ps_exchange_fee: e.target.value.replace(/[^0-9]/g,'')}))} placeholder="0"
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                </div>
              </div>

              <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '14px', marginTop: '14px' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', color: '#444', marginBottom: '10px' }}>제주/도서산간 배송</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', maxWidth: '560px' }}>
                  <div>
                    <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>배송 권역</div>
                    <div style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#f9f9f9', color: '#666' }}>2권역 (제주+도서산간 통합)</div>
                  </div>
                  <div>
                    <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>추가 배송비</div>
                    <input value={psForm.ps_jeju_extra_fee} onChange={e => setPsForm(p=>({...p, ps_jeju_extra_fee: e.target.value.replace(/[^0-9]/g,'')}))} placeholder="8000"
                      style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                  </div>
                </div>
              </div>

              <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '14px', marginTop: '14px' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', color: '#444', marginBottom: '10px' }}>반품안심케어</div>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '12px', color: '#444', cursor: 'pointer' }}>
                  <input type="checkbox" checked={psForm.ps_free_return_insurance === 'true'} onChange={e => setPsForm(p=>({...p, ps_free_return_insurance: e.target.checked ? 'true' : 'false'}))} />
                  반품안심케어 설정함 (서비스 이용 중인 경우에만 체크)
                </label>
              </div>

              <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '14px', marginTop: '14px' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', color: '#444', marginBottom: '10px' }}>구매 리뷰 포인트</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', maxWidth: '560px' }}>
                  <div>
                    <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>텍스트 리뷰 (원)</div>
                    <input value={psForm.ps_review_text_point} onChange={e => setPsForm(p=>({...p, ps_review_text_point: e.target.value.replace(/[^0-9]/g,'')}))} placeholder="50"
                      style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                  </div>
                  <div>
                    <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>포토/동영상 리뷰 (원)</div>
                    <input value={psForm.ps_review_photo_point} onChange={e => setPsForm(p=>({...p, ps_review_photo_point: e.target.value.replace(/[^0-9]/g,'')}))} placeholder="150"
                      style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                  </div>
                </div>
              </div>

              <div style={{ borderTop: '0.5px solid #e8e8e8', paddingTop: '14px', marginTop: '4px' }}>
                <div style={{ fontSize: '12px', fontWeight: '500', color: '#444', marginBottom: '4px' }}>상세페이지 공통 하단 이미지 (최대 6장)</div>
                <div style={{ fontSize: '11px', color: '#aaa', marginBottom: '10px', lineHeight: '1.5' }}>
                  상품 상세페이지 하단에 공통으로 들어갈 이미지입니다(반품/교환 안내 등). 이미지를 추가·교체한 뒤 [네이버 업로드]를 눌러 미리 전송해두면, 실제 상품을 등록할 때마다 다시 올리지 않고 저장된 이미지를 바로 재사용합니다. "미전송" 상태인 이미지는 상품 등록 시 자동으로 사용되지 않으니, 등록 전에 한 번은 눌러 "전송됨"으로 만들어주세요.
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '10px' }}>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <label style={{ fontSize: '11px', padding: '5px 12px', borderRadius: '6px', border: '0.5px solid #1D9E75', background: imgUploading ? '#f0f0f0' : '#E1F5EE', color: imgUploading ? '#aaa' : '#085041', cursor: imgUploading || commonImages.length >= 6 ? 'not-allowed' : 'pointer' }}>
                      {imgUploading ? '업로드 중...' : '이미지 추가'}
                      <input type="file" accept="image/*" multiple disabled={imgUploading || commonImages.length >= 6} onChange={handleCommonImageUpload} style={{ display: 'none' }} />
                    </label>
                    <button onClick={pushImagesToNaver} disabled={naverPushing || commonImages.length === 0}
                      style={{ fontSize: '11px', padding: '5px 12px', borderRadius: '6px', border: '0.5px solid #185FA5', background: naverPushing ? '#f0f0f0' : '#E6F1FB', color: naverPushing ? '#aaa' : '#185FA5', cursor: naverPushing || commonImages.length === 0 ? 'not-allowed' : 'pointer' }}>
                      {naverPushing ? '전송 중...' : '네이버 업로드'}
                    </button>
                  </div>
                </div>
                {commonImages.length === 0 ? (
                  <div style={{ fontSize: '12px', color: '#aaa', padding: '20px', textAlign: 'center', border: '1px dashed #ddd', borderRadius: '8px' }}>등록된 이미지가 없습니다</div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '8px' }}>
                    {commonImages.map((img, idx) => (
                      <div key={idx} style={{ position: 'relative', border: '0.5px solid #e8e8e8', borderRadius: '8px', overflow: 'hidden', background: '#fafafa' }}>
                        <div style={{ aspectRatio: '1', overflow: 'hidden' }}>
                          <img src={`https://admin.jinhalife.co.kr${img.local}`} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                        <div style={{ position: 'absolute', top: '4px', left: '4px', fontSize: '9px', padding: '1px 5px', borderRadius: '4px', background: img.naver ? '#1D9E75' : '#EF9F27', color: '#fff', fontWeight: '500' }}>
                          {img.naver ? '전송됨' : '미전송'}
                        </div>
                        <div style={{ display: 'flex', gap: '2px', padding: '3px', background: '#fff' }}>
                          <button onClick={() => moveCommonImage(idx, -1)} disabled={idx === 0} style={{ flex: 1, fontSize: '10px', padding: '2px', border: '0.5px solid #ddd', borderRadius: '4px', background: '#fff', cursor: idx === 0 ? 'not-allowed' : 'pointer', color: idx === 0 ? '#ccc' : '#666' }}>◀</button>
                          <label style={{ flex: 1, fontSize: '10px', padding: '2px', border: '0.5px solid #ddd', borderRadius: '4px', background: '#fff', cursor: 'pointer', textAlign: 'center', color: '#666' }}>
                            교체
                            <input type="file" accept="image/*" onChange={e => handleCommonImageReplace(idx, e)} style={{ display: 'none' }} />
                          </label>
                          <button onClick={() => moveCommonImage(idx, 1)} disabled={idx === commonImages.length - 1} style={{ flex: 1, fontSize: '10px', padding: '2px', border: '0.5px solid #ddd', borderRadius: '4px', background: '#fff', cursor: idx === commonImages.length - 1 ? 'not-allowed' : 'pointer', color: idx === commonImages.length - 1 ? '#ccc' : '#666' }}>▶</button>
                        </div>
                        <button onClick={() => removeCommonImage(idx)} style={{ width: '100%', fontSize: '10px', padding: '2px', border: 'none', borderTop: '0.5px solid #e8e8e8', background: '#fff5f5', color: '#e53935', cursor: 'pointer' }}>삭제</button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </Section>

          <Section title="스마트스토어 설정" desc="스마트스토어 전용 값입니다. 주소록을 불러온 뒤 출고지/반품지를 선택하세요">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
              <button onClick={loadAddressBooks} disabled={addrLoading}
                style={{ fontSize: '12px', padding: '7px 16px', borderRadius: '8px', border: '0.5px solid #1D9E75', background: addrLoading ? '#f0f0f0' : '#E1F5EE', color: addrLoading ? '#aaa' : '#085041', cursor: addrLoading ? 'not-allowed' : 'pointer', fontWeight: '500' }}>
                {addrLoading ? '불러오는 중...' : '주소록 불러오기'}
              </button>
              {addressBooks.length > 0 && <span style={{ fontSize: '11px', color: '#888' }}>총 {addressBooks.length}건</span>}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', maxWidth: '560px' }}>
              {[
                { key: 'shipping', label: '출고지', type: 'RELEASE', idKey: 'ps_naver_shipping_address_id', labelKey: 'ps_naver_shipping_address_label' },
                { key: 'return', label: '반품/교환지', type: 'REFUND_OR_EXCHANGE', idKey: 'ps_naver_return_address_id', labelKey: 'ps_naver_return_address_label' },
              ].map(f => (
                <div key={f.key}>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>{f.label}</div>
                  {addressBooks.length > 0 ? (
                    <select value={psForm[f.idKey]} onChange={e => {
                      const sel = addressBooks.find(a => String(a.addressBookNo) === e.target.value);
                      setPsForm(p => ({ ...p, [f.idKey]: e.target.value, [f.labelKey]: sel ? `${sel.name} · ${sel.address || sel.baseAddress || ''}` : '' }));
                    }} style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', background: '#fff' }}>
                      <option value="">--선택--</option>
                      {addressBooks.filter(a => a.addressType === f.type).map(a => (
                        <option key={a.addressBookNo} value={a.addressBookNo}>{a.name} · {a.address || a.baseAddress}</option>
                      ))}
                    </select>
                  ) : (
                    <div style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #e8e8e8', background: '#f9f9f9', color: psForm[f.idKey] ? '#1a1a1a' : '#aaa', minHeight: '33px', boxSizing: 'border-box' }}>
                      {psForm[f.labelKey] || (psForm[f.idKey] ? `ID ${psForm[f.idKey]}` : '미설정')}
                    </div>
                  )}
                </div>
              ))}
            </div>
            {addressBooks.length === 0 && (
              <div style={{ fontSize: '11px', color: '#aaa', marginTop: '8px' }}>변경하려면 위의 [주소록 불러오기] 버튼을 눌러주세요.</div>
            )}
          </Section>

          <Section title="ESM(지마켓/옥션) 배송 설정" desc="ESM 상품일괄등록메뉴 > 배송정보 코드 조회에서 확인한 값을 입력하세요">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', maxWidth: '560px' }}>
              {[
                { key: 'esm_outbound_location_code', label: '출하지 코드' },
                { key: 'esm_delivery_policy_no', label: '배송정책번호(배송비 코드)' },
                { key: 'esm_return_address_code', label: '반품/교환 주소 코드' },
                { key: 'esm_auction_dispatch_policy', label: 'A(옥션) 발송정책 코드 (기본 2일)' },
                { key: 'esm_gmarket_dispatch_policy', label: 'G(지마켓) 발송정책 코드 (기본 2일)' },
                { key: 'esm_auction_dispatch_policy_3d', label: 'A(옥션) 발송정책 코드 (3일)' },
                { key: 'esm_gmarket_dispatch_policy_3d', label: 'G(지마켓) 발송정책 코드 (3일)' },
                { key: 'esm_auction_dispatch_policy_4d', label: 'A(옥션) 발송정책 코드 (4일)' },
                { key: 'esm_gmarket_dispatch_policy_4d', label: 'G(지마켓) 발송정책 코드 (4일)' },
                { key: 'esm_delivery_method', label: '배송방법 (일반택배/직접배송)' },
              ].map(f => (
                <div key={f.key}>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>{f.label}</div>
                  <input value={psForm[f.key]} onChange={e => setPsForm(p => ({ ...p, [f.key]: e.target.value }))}
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                </div>
              ))}
            </div>
          </Section>
          <Section title="11번가 상품등록 설정" desc="출고지/반품지/발송마감 템플릿 등 11번가 상품등록에 쓰이는 고정값을 관리합니다">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', maxWidth: '560px' }}>
              {[
                { key: 'eleven_addr_seq_out', label: '출고지 번호' },
                { key: 'eleven_addr_seq_in', label: '반품/교환지 번호' },
                { key: 'eleven_send_close_tmplt_no', label: '발송마감 템플릿 번호 (기본 2일)' },
                { key: 'eleven_send_close_tmplt_no_3d', label: '발송마감 템플릿 번호 (3일)' },
                { key: 'eleven_send_close_tmplt_no_4d', label: '발송마감 템플릿 번호 (4일)' },
                { key: 'eleven_rmaterial_typ_cd', label: '원산지 의무표시 코드' },
                { key: 'eleven_orgn_typ_cd', label: '원산지 코드' },
              ].map(f => (
                <div key={f.key}>
                  <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>{f.label}</div>
                  <input value={psForm[f.key]} onChange={e => setPsForm(p => ({ ...p, [f.key]: e.target.value }))}
                    style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
                </div>
              ))}
            </div>
          </Section>
          <Section title="토스쇼핑 상품등록 설정" desc="교환/반품 신청 방법·기간 설명만 별도 관리합니다. 배송비/교환반품비/택배사 등은 기존 상품등록 공통설정과 택배사 관리 화면 값을 그대로 재사용합니다">
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', maxWidth: '560px' }}>
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>교환/반품 신청 방법 설명</div>
                <input value={psForm.toss_application_method_description} onChange={e => setPsForm(p => ({ ...p, toss_application_method_description: e.target.value }))}
                  style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
              </div>
              <div style={{ gridColumn: '1 / -1' }}>
                <div style={{ fontSize: '11px', color: '#888', marginBottom: '4px' }}>교환/반품 신청 가능 기간 설명</div>
                <input value={psForm.toss_application_term_description} onChange={e => setPsForm(p => ({ ...p, toss_application_term_description: e.target.value }))}
                  style={{ fontSize: '12px', padding: '7px 10px', borderRadius: '8px', border: '0.5px solid #ddd', width: '100%', boxSizing: 'border-box' }} />
              </div>
            </div>
          </Section>
          <SellerhubBrandSection />

          <Section title="카테고리 매핑" desc="우리 카테고리(3,452개)를 네이버 카테고리ID와 연결합니다. 먼저 동기화 후 자동 매칭을 실행하세요">
            <div style={{ display: 'flex', gap: '10px', marginBottom: '12px' }}>
              <button onClick={syncNaverCategories} disabled={catSyncing}
                style={{ fontSize: '12px', padding: '7px 16px', borderRadius: '8px', border: '0.5px solid #185FA5', background: catSyncing ? '#f0f0f0' : '#E6F1FB', color: catSyncing ? '#aaa' : '#185FA5', cursor: catSyncing ? 'not-allowed' : 'pointer', fontWeight: '500' }}>
                {catSyncing ? '동기화 중...' : '① 네이버 카테고리 동기화'}
              </button>
              <button onClick={runAutoMatch} disabled={catMatching}
                style={{ fontSize: '12px', padding: '7px 16px', borderRadius: '8px', border: '0.5px solid #1D9E75', background: catMatching ? '#f0f0f0' : '#E1F5EE', color: catMatching ? '#aaa' : '#085041', cursor: catMatching ? 'not-allowed' : 'pointer', fontWeight: '500' }}>
                {catMatching ? '매칭 중...' : '② 자동 매칭 실행'}
              </button>
            </div>
            {catSyncMsg && <div style={{ fontSize: '12px', color: '#1D9E75', marginBottom: '10px' }}>{catSyncMsg}</div>}
            {catMatchResult && (
              <div style={{ fontSize: '12px', color: '#444', background: '#f9f9f9', borderRadius: '8px', padding: '10px 14px', lineHeight: '1.8' }}>
                {catMatchResult.message} / 매칭 안 된 카테고리: {catMatchResult.unmatchedCount}건
                {catMatchResult.unmatchedCount > 0 && (
                  <button onClick={loadUnmatched} disabled={unmatchedLoading}
                    style={{ marginLeft: '10px', fontSize: '11px', padding: '4px 10px', borderRadius: '6px', border: '0.5px solid #EF9F27', background: '#FAEEDA', color: '#854F0B', cursor: 'pointer' }}>
                    {unmatchedLoading ? '불러오는 중...' : '미매칭 목록 열어서 수동 매칭'}
                  </button>
                )}
              </div>
            )}
            {showUnmatched && (
              <div style={{ marginTop: '12px', border: '0.5px solid #eee', borderRadius: '8px', padding: '10px', maxHeight: '400px', overflowY: 'auto' }}>
                <div style={{ fontSize: '11px', color: '#888', marginBottom: '8px' }}>남은 미매칭: {unmatchedList.length}건</div>
                {unmatchedList.length === 0 && <div style={{ fontSize: '12px', color: '#1D9E75', padding: '10px' }}>모두 매칭됐습니다 🎉</div>}
                {unmatchedList.map(c => (
                  <UnmatchedCategoryRow key={c.id} cat={c} onMatch={applyManualMatch} />
                ))}
              </div>
            )}
          </Section>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', alignItems: 'center' }}>
            {psSaveMsg && <span style={{ fontSize: '12px', color: '#1D9E75' }}>{psSaveMsg}</span>}
            {psSavedAt && (
              <span style={{ fontSize: '11px', color: '#aaa' }}>
                마지막 저장: {new Date(psSavedAt).toLocaleString('ko-KR', { timeZone: 'Asia/Seoul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })}
              </span>
            )}
            <button onClick={async () => {
              const payload = { ...psForm };
              if (addressBooks.length > 0) {
                const mk = (id) => {
                  const a = addressBooks.find(x => String(x.addressBookNo) === String(id));
                  return a ? `${a.name} · ${a.address || a.baseAddress || ''}` : '';
                };
                if (payload.ps_naver_shipping_address_id) payload.ps_naver_shipping_address_label = mk(payload.ps_naver_shipping_address_id);
                if (payload.ps_naver_return_address_id) payload.ps_naver_return_address_label = mk(payload.ps_naver_return_address_id);
              }
              await api.post('/product-settings', payload);
              setPsForm(payload);
              setPsSaveMsg('저장됐습니다');
              setTimeout(() => setPsSaveMsg(''), 3000);
              loadProductSettings();
            }} style={{ fontSize: '12px', padding: '8px 24px', borderRadius: '8px', border: 'none', background: '#1D9E75', color: '#fff', cursor: 'pointer', fontWeight: '500' }}>저장</button>
          </div>
        </div>
      )}
      {tab === 'marginSettings' && <MarginSettingsSection />}
      {tab === 'productGroups' && <ProductGroupSection showMsg={showMsg} />}
    </div>
  );
}
